var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvrtInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.84615C6.39219 1.84615 1.84615 6.39219 1.84615 12C1.84615 17.6078 6.39219 22.1538 12 22.1538C17.6078 22.1538 22.1538 17.6078 22.1538 12C22.1538 6.39219 17.6078 1.84615 12 1.84615ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM11.0769 7.07692C11.0769 6.56712 11.4902 6.15385 12 6.15385H12.0123C12.5221 6.15385 12.9354 6.56712 12.9354 7.07692C12.9354 7.58672 12.5221 8 12.0123 8H12C11.4902 8 11.0769 7.58672 11.0769 7.07692ZM9.84615 10.7692C9.84615 10.2594 10.2594 9.84615 10.7692 9.84615H12C12.5098 9.84615 12.9231 10.2594 12.9231 10.7692V16H13.2308C13.7406 16 14.1538 16.4133 14.1538 16.9231C14.1538 17.4329 13.7406 17.8462 13.2308 17.8462H12C11.4902 17.8462 11.0769 17.4329 11.0769 16.9231V11.6923H10.7692C10.2594 11.6923 9.84615 11.279 9.84615 10.7692Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvrtInfoOutlined);
export default __webpack_public_path__ + "static/media/convrt_info_outlined.a0646a8aa26020bb7befc4442220b148.svg";
export { ForwardRef as ReactComponent };